(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__weirdWing) return;
  window.__weirdWing = true;

  function ready(fn){ if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',fn);}else{fn();} }

  ready(function () {
    var drawer = document.querySelector('[data-filter-drawer]');
    var scrim  = document.querySelector('[data-filter-scrim]');
    var openBtn = document.querySelector('[data-filter-open]');
    if (!drawer || !openBtn) return;
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      scrim.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      openBtn.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function(){ drawer.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      var f = drawer.querySelector('input,select,button');
      if (f) f.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      window.setTimeout(function(){ drawer.setAttribute('aria-hidden','true'); scrim.hidden = true; }, 260);
      if (lastFocus) lastFocus.focus();
    }
    openBtn.addEventListener('click', open);
    scrim.addEventListener('click', close);
    var closeBtn = drawer.querySelector('[data-filter-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function(e){ if(e.key==='Escape' && drawer.getAttribute('aria-hidden')==='false') close(); });

    // sort auto-applies
    var sortSel = document.querySelector('[data-sort-select]');
    if (sortSel) sortSel.addEventListener('change', function(){ this.form.submit(); });

    // price quick bands write into the min/max inputs
    var form = drawer.querySelector('[data-filter-form]');
    if (!form) return;
    drawer.querySelectorAll('.quickband').forEach(function (b) {
      b.addEventListener('click', function () {
        var min = form.querySelector('[name="' + b.dataset.minName + '"]');
        var max = form.querySelector('[name="' + b.dataset.maxName + '"]');
        var on = b.classList.contains('is-on');
        drawer.querySelectorAll('.quickband').forEach(function(x){ x.classList.remove('is-on'); });
        if (on) { if(min) min.value=''; if(max) max.value=''; }
        else { b.classList.add('is-on'); if(min) min.value = b.dataset.bandMin || ''; if(max) max.value = b.dataset.bandMax || ''; }
        refresh();
      });
    });

    // live result count on the apply button
    var countEl = drawer.querySelector('[data-filter-count]');
    var base = window.location.pathname;
    var token = 0;
    function refresh() {
      if (!countEl) return;
      var params = new URLSearchParams(new FormData(form));
      var clean = new URLSearchParams();
      params.forEach(function (v, k) { if (v !== '') clean.append(k, v); });
      clean.set('view', 'count');
      var mine = ++token;
      fetch(base + '?' + clean.toString(), { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { return r.text(); })
        .then(function (t) {
          if (mine !== token) return;
          var m = t.match(/WSCOUNT:(\d+)/);
          if (m) countEl.textContent = m[1];
        })
        .catch(function () {});
    }
    form.addEventListener('change', refresh);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-finder"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__weirdQuickFinder) return;
  window.__weirdQuickFinder = true;
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-quick-finder]');
    if (!form) return;
    // drop empty axes so the resulting URL only carries real choices
    var fields = form.querySelectorAll('select');
    for (var i = 0; i < fields.length; i++) {
      if (fields[i].value === '') fields[i].disabled = true;
    }
    window.setTimeout(function () {
      for (var j = 0; j < fields.length; j++) fields[j].disabled = false;
    }, 0);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
